export interface DocumentVersion {
  number: string;
  title?: string;
  createdBy: string;
  checkedIn: string;
  nodeRef: string;
  location: string;
  workingCopyExists: boolean;
  name: string;
}
